<template>
  <div class="roleAccountAssignDialog">
    <!-- 部分设置弹窗 -->
    <el-dialog class="dialog1000" title="用户授权" :visible.sync="isAccountDialogShow" :close-on-click-modal="false">
      <div class="screenPanel">
        <el-form ref="selectform" :model="selectform" label-width="60px" :inline="true">
          <el-col :span="6">
            <el-form-item label="用户名" prop="userName">
              <el-input v-model="selectform.userName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="性别" prop="sex">
              <el-select v-model="selectform.sex">
                <el-option value label="全部"></el-option>
                <el-option value="1" label="男"></el-option>
                <el-option value="0" label="女"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="是否授权" prop="isEmpower" label-width="70px">
              <el-select v-model="selectform.isEmpower">
                <el-option value label="全部"></el-option>
                <el-option value="1" label="未授权"></el-option>
                <el-option value="0" label="已授权"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-form>
        <el-col :span="6" style="text-align:right;">
          <el-button type="primary" @click="selectBtn()">查询</el-button>
          <el-button type="info" @click="resetBtn()">重置</el-button>
        </el-col>
      </div>
      <el-table
        ref="accountTable"
        :data="accountList"
        highlight-current-row
        size="mini"
        :height="418"
        @selection-change="accountChanged"
        @row-click="rowClicked"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column prop="userName" label="用户名" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="adminFlag" label="管理员" :show-overflow-tooltip="true">
          <template slot-scope="props">{{props.row.adminFlag==1?'管理员':'非管理员'}}</template>
        </el-table-column>
        <el-table-column prop="sex" label="性别" :show-overflow-tooltip="true">
          <template slot-scope="props">{{props.row.sex==1?'男':'女'}}</template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号码" :show-overflow-tooltip="true"></el-table-column>
      </el-table>
      <el-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="selectform.page"
          :page-sizes="[10, 20, 30, 40,50]"
          :page-size="selectform.rows"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total"
        ></el-pagination>
      </el-footer>
      <el-row>
        <el-col :span="24" style="text-align:left;margin-top:20px;">
          <span class="numTitle">新增授权:</span>
          <span class="num">{{addAccount}}</span>
          <span class="numTitle">取消授权:</span>
          <span class="num">{{delAccount}}</span>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="closeDialog()">取 消</el-button>
        <el-button type="primary" @click="savePostClick()">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAreaListByUserCodeService } from "../../services/commonService";
import {
  getRoleAssginUserCurrentPageeService,
  getAccountRolePageService,
  authRoleUserService
} from "../../services/sysSettingService";
export default {
  name: "roleAccountAssignDialog",
  data() {
    return {
      total: 0, //总数
      accountList: [], //账号列表
      postList: [], //岗位列表
      userPostKeys: [], //初始选中的岗位列表
      accountSelectedList: [],
      newUsers: [],
      currentUsers: "", //当前页的用户ID，以逗号分隔
      isAccountDialogShow: false, //新增/修改用户显示开关
      isAddFlag: true, //新增/修改标识
      roleId: "",
      postCodeSelected: "",
      defaultProps: {
        label: "text",
        children: "children",
        value: "id"
      },
      selectform: {
        userName: "",
        sex: "",
        isEmpower: "",
        page: 1,
        rows: 10
      },
      addAccount:0,
      delAccount:0,
      isShowAccount:false
    };
  },
  methods: {
    refreshAccount(roleId) {
      this.isAccountDialogShow = true;
      this.roleId = roleId;
      this.getAccountRolePage();
    },
    /* 获取角色可授权用户列表*/
    getAccountRolePage() {
      this.addAccount = 0;
      this.delAccount = 0;
      this.selectform.roleCode = this.roleId;
      getAccountRolePageService(this.selectform).then(
        res => {
          console.log(res);
          if (res.resultCode == 0) {
            this.total = res.data.total;
            this.accountList = res.data.list;
            this.currentUsers = "";
            this.accountList.forEach(account => {
              this.currentUsers += account.userCode + ",";
            });
            this.getRoleAssginUserCurrentPagee(this.currentUsers);
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 用户授权请求 */
    authRoleUser(newUserCodes, oldUserCodes) {
      let params = {
        oldUserCodes: oldUserCodes,
        newUserCodes: newUserCodes,
        roleCode: this.roleId,
        userCode: sessionStorage.getItem("userCode")
      };
      authRoleUserService(params).then(
        res => {
          console.log(res);
          if (res.resultCode == 0) {
            this.$alert("授权成功", "提示");
            this.isAccountDialogShow = false;
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 获取角色已授权用户列表*/
    getRoleAssginUserCurrentPagee(userIds) {
      let reqParam = {
        roleId: this.roleId,
        ids: userIds
      };
      this.isShowAccount = false;
      getRoleAssginUserCurrentPageeService(reqParam).then(
        res => {
          if (res.resultCode == 0) {
            this.newUsers=[];
            this.accountSelectedList = res.data;
            this.accountSelectedList.forEach(accountSelected => {
              this.accountList.forEach(account => {
                if (account.userCode == accountSelected) {
                  this.$refs.accountTable.toggleRowSelection(account, true);
                }
              });
            });
            this.isShowAccount = true;
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 分页改变事件 */
    handleCurrentChange(page) {
      console.log(page);
      this.selectform.page = page;
      this.getAccountRolePage();
    },
    /* 分页显示数量改变事件 */
    handleSizeChange(rows) {
      this.selectform.rows = rows;
      this.selectform.page = 1;
      this.getAccountRolePage();
    },
    /* 保存按钮回调 */
    savePostClick() {
      let newUserCodes = [];
      if (this.newUsers) {
        newUserCodes = this.newUsers
      } else {
        newUserCodes = this.accountSelectedList;
      }
      this.authRoleUser(newUserCodes, this.accountSelectedList);
    },
    /* 用户多选回调 */
    accountChanged(users) {
      console.log(users);
      this.newUsers=[];
      users.forEach(user => {
        this.newUsers.push(user.userCode);
      });

      if(!this.isShowAccount)
       return;
      let num = 0;
      this.accountSelectedList.forEach(selected=>{
        let index = this.newUsers.indexOf(selected);
        if(index == -1){
          num++;
        }
      });
      this.delAccount=num;

      num = 0;
      this.newUsers.forEach(selected=>{
        let index = this.accountSelectedList.indexOf(selected);
        if(index == -1){
          num++;
        }
      });
      this.addAccount=num;
    },
    // 点击选中行
    rowClicked(row, event, column) {
      this.$refs.accountTable.toggleRowSelection(row);
    },
    /* 查询按钮回调 */
    selectBtn() {
      this.getAccountRolePage();
    },
    /* 重置按钮回调 */
    resetBtn() {
      this.$refs.selectform.resetFields();
    },
    closeDialog(){
      this.$refs.selectform.resetFields();
      this.selectform.page= 1;
      this.selectform.rows= 10;
      this.isAccountDialogShow = false;
    }
  }
};
</script>

<style scoped lang="scss">
.roleAccountAssignDialog {
  // height: 100%;
  background-color: white;
}
.areaAside {
  width: 70% !important;
}
.el-container {
  height: 100%;
  .el-aside {
    height: 100%;
  }
}
.el-select {
  width: 100%;
}
.el-form-item__label {
  text-align: left;
}
/deep/.el-form-item__content {
  width: 65%;
}
.el-footer {
  text-align: right;
}
/deep/.el-dialog {
  width: 60%;
  .el-dialog__body {
    background-color: #f0f5f7;
  }
  .el-table th > .cell {
    font-size: 14px;
    color: #444444;
  }
  .el-footer {
    background-color: #fff;
    padding-top: 10px;
  }
}
.numTitle{
  margin-right: 8px;
}
.num{
  margin-right: 8px;
  color: red;
  font-weight: bold;
  font-size: 28px;
  width: 20px;
}
.postPanel {
  padding: 10px 23px;
  background-color: #fff;
  text-align: left;
  font-size: 14px;
  margin-bottom: 1px;
  color: #444444;
  .canelPostBtn {
    float: right;
    color: #079dbd;
  }
}
</style>
